import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

export const TrustCopyBlock = () => (
  <div className="ps-container-lg-margin ps-container-fixed tw-relative tw-mt-56">
    <div className="ps-row">
      <div className="col-xs-12 tw-flex tw-flex-col tw-items-center tw-text-center tw-w-full tw-gap-16 lg:tw-gap-12">
        <div className="tw-flex tw-flex-col tw-w-full">
          <Text
            element="p"
            typeface="headline-1-m"
            className="lg:tw-headline-3-m tw-text-brand-purple tw-mb-16 lg:tw-mb-0"
          >
            <FormattedMessage defaultMessage="Every space belongs" />
          </Text>
          <Text
            element="h2"
            typeface="headline-4-m"
            className="lg:tw-headline-6-m tw-text-brand-white"
          >
            <FormattedMessage defaultMessage="From living rooms to soundstages" />
          </Text>
        </div>
        <Text
          element="p"
          typeface="body-3"
          className="tw-text-brand-white tw-w-full lg:tw-max-w-[420px]"
        >
          <FormattedMessage defaultMessage="The diversity of spaces is what makes Peerspace special. If people would love to use it, it belongs here." />
        </Text>
      </div>
    </div>
  </div>
);
